module.exports = __webpack_public_path__ + "img/open_24.a6905a42.svg";